import ScrollButton from '../components/scroll_button';
import InfoSection from '../components/info_section';
import Layout from '../components/layout';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import styles from '../styles/cookies.module.scss';

export default function Cookies() {
  const router = useRouter();
  const { t } = useTranslation('cookies');

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
        <div className={styles.content}>
            <h3>{t('titleCookie')}</h3>
            <div className={styles.block}>
                <p dangerouslySetInnerHTML={{__html: t('firstLeft', { interpolation: { escapeValue: false }})}}/>
                <p dangerouslySetInnerHTML={{__html: t('firstCenter', { interpolation: { escapeValue: false }})}}/>
                <p dangerouslySetInnerHTML={{__html: t('firstRight', { interpolation: { escapeValue: false }})}}/>
            </div>
            <div className={styles.block}>
                <p dangerouslySetInnerHTML={{__html: t('secondLeft', { interpolation: { escapeValue: false }})}}/>
                <p dangerouslySetInnerHTML={{__html: t('secondCenter', { interpolation: { escapeValue: false }})}}/>
                <p dangerouslySetInnerHTML={{__html: t('secondRight', { interpolation: { escapeValue: false }})}}/>
            </div>
            <div className={styles.block}>
                <p dangerouslySetInnerHTML={{__html: t('thirdLeft', { interpolation: { escapeValue: false }})}}/>
                <p dangerouslySetInnerHTML={{__html: t('thirdCenter', { interpolation: { escapeValue: false }})}}/>
                <p dangerouslySetInnerHTML={{__html: t('thirdRight', { interpolation: { escapeValue: false }})}}/>
            </div>
        </div>
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['cookies', 'common']),
  },
});
